import { DM_Sans as DMSans } from 'next/font/google'
import { useEffect } from 'react'
import { isAppUrl, withAttribution } from '@src/functions/attribution'
import Footer from './footer'
import Header from './Header'

const dmSans = DMSans({
  weight: ['700', '500', '400'],
  style: 'normal',
  subsets: ['latin'],
})

/**
 * Last line of defence for paid-traffic attribution: rewrite any anchor into
 * the booking app on the way out so it carries the session's gclid/utm_*
 * params. The CTAs that matter stamp their own href via `useAppLink`, but links
 * into the app are hand-rolled in dozens of places — including inside blog HTML
 * we render with dangerouslySetInnerHTML — and an unattributed booking is
 * invisible in campaign reporting. Capture phase so it lands before next/link's
 * own handler; next/link leaves external URLs to the browser and the browser
 * reads the href we just rewrote.
 */
function useAppLinkAttribution() {
  useEffect(() => {
    const stampLink = (event: MouseEvent) => {
      const anchor = (event.target as HTMLElement | null)?.closest?.('a')
      if (!anchor || !anchor.href || !isAppUrl(anchor.href)) return
      const stamped = withAttribution(anchor.href)
      if (stamped !== anchor.href) anchor.href = stamped
    }

    // `auxclick` covers middle-click / open-in-new-tab.
    document.addEventListener('click', stampLink, true)
    document.addEventListener('auxclick', stampLink, true)
    return () => {
      document.removeEventListener('click', stampLink, true)
      document.removeEventListener('auxclick', stampLink, true)
    }
  }, [])
}

function Layout({ children }: { children: any }) {
  useAppLinkAttribution()

  return (
    <>
      <div id='modal-portal' />
      <Header />
      <main className={dmSans.className}>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
